import type {} from "typed-query-selector";
import "./view/app";
